<template>
  <div class="home">
    <div class="home-content">
      <img src="../assets/Clipped.png" alt="" />
      <div class="content">
        <!-- 核心业务 -->
        <div class="core-business">
          <div class="core-business-header">
            <h2>核心业务</h2>
            <p>我们提供全方位的数字化解决方案，从策略规划到技术支持，助力企业实现数字化转型</p>
          </div>
          <div class="core-business-cards">
            <div class="core-business-card">
              <div class="core-business-icon">
                <img src="../assets/icon_ad.png" alt="广告策划" />
              </div>
              <h3>广告策划</h3>
              <p>精准定位目标受众，制定创意营销策略，提升品牌影响力和市场竞争力</p>
              <div class="core-business-more" @click="handleMore('/advertisement', 1)">查看详情 →</div>
            </div>
            <div class="core-business-card">
              <div class="core-business-icon">
                <img src="../assets/icon_com.png" alt="企业咨询" />
              </div>
              <h3>企业咨询</h3>
              <p>专业顾问团队提供战略指导，优化业务流程，提升运营效率和管理水平</p>
              <div class="core-business-more" @click="handleMore('/consult', 2)">查看详情 →</div>
            </div>
            <div class="core-business-card">
              <div class="core-business-icon">
                <img src="../assets/icon_match.png" alt="数字内容制作" />
              </div>
              <h3>数字内容制作</h3>
              <p>高质量视频、图文内容创作，打造品牌形象，增强用户互动体验</p>
              <div class="core-business-more" @click="handleMore('/digit', 3)">查看详情 →</div>
            </div>
            <div class="core-business-card">
              <div class="core-business-icon">
                <img src="../assets/icon_steam.png" alt="系统平台搭建" />
              </div>
              <h3>系统平台搭建</h3>
              <p>定制化系统开发，灵活扩展，保障数据安全，支持业务持续发展</p>
              <div class="core-business-more" @click="handleMore('/platform', 4)">查看详情 →</div>
            </div>
          </div>
        </div>
        <!-- 数据统计 -->
        <div class="stats">
          <div class="stats-item">
            <div class="stats-number">500+</div>
            <div class="stats-label">成功项目</div>
          </div>
          <div class="stats-item">
            <div class="stats-number">200+</div>
            <div class="stats-label">合作伙伴</div>
          </div>
          <div class="stats-item">
            <div class="stats-number">50+</div>
            <div class="stats-label">专业团队</div>
          </div>
          <div class="stats-item">
            <div class="stats-number">98%</div>
            <div class="stats-label">客户满意度</div>
          </div>
        </div>
        <!-- 成功案例 -->
        <div class="case-studies">
          <div class="case-studies-header">
            <h2>成功案例</h2>
            <p>我们为各行各业的企业提供了优质的数字化解决方案，以下是部分成功案例</p>
          </div>
          <div class="case-studies-grid">
            <div class="case-studies-item">
              <img src="../assets/bg_zx.png" alt="科技公司数字化转型" />
              <h3>科技公司数字化转型</h3>
              <p>通过定制化系统搭建和数据分析，帮助客户提升了30%的运营效率</p>
              <!-- <div class="case-studies-footer">
                <div class="case-studies-status">已完成</div>
                <div class="case-studies-date">2024年</div>
              </div> -->
            </div>
            <div class="case-studies-item">
              <img src="../assets/bg_js.png" alt="电商平台建设" />
              <h3>电商平台建设</h3>
              <p>全栈式电商解决方案，实现了月销售额增长50%的显著成效</p>
              <!-- <div class="case-studies-footer">
                <div class="case-studies-status">已完成</div>
                <div class="case-studies-date">2024年</div>
              </div> -->
            </div>
            <div class="case-studies-item">
              <img src="../assets/bg_ch.png" alt="品牌广告策划" />
              <h3>品牌广告策划</h3>
              <p>创意广告策略实施，使品牌知名度提升了40%，市场反响热烈</p>
              <!-- <div class="case-studies-footer">
                <div class="case-studies-status">已完成</div>
                <div class="case-studies-date">2024年</div>
              </div> -->
            </div>
            <div class="case-studies-item">
              <img src="../assets/bg_zx2.png" alt="科技公司数字化转型" />
              <h3>科技公司数字化转型</h3>
              <p>通过定制化系统搭建和数据分析，帮助客户提升了30%的运营效率</p>
              <!-- <div class="case-studies-footer">
                <div class="case-studies-status">已完成</div>
                <div class="case-studies-date">2024年</div>
              </div> -->
            </div>
            <div class="case-studies-item">
              <img src="../assets/bg_steam.png" alt="电商平台建设" />
              <h3>电商平台建设</h3>
              <p>全栈式电商解决方案，实现了月销售额增长50%的显著成效</p>
              <!-- <div class="case-studies-footer">
                <div class="case-studies-status">已完成</div>
                <div class="case-studies-date">2024年</div>
              </div> -->
            </div>
            <div class="case-studies-item">
              <img src="../assets/bg_ch.png" alt="品牌广告策划" />
              <h3>品牌广告策划</h3>
              <p>创意广告策略实施，使品牌知名度提升了40%，市场反响热烈</p>
              <!-- <div class="case-studies-footer">
                <div class="case-studies-status">已完成</div>
                <div class="case-studies-date">2024年</div>
              </div> -->
            </div>
            <div class="case-studies-item">
              <img src="../assets/bg_ch2.png" alt="科技公司数字化转型" />
              <h3>科技公司数字化转型</h3>
              <p>通过定制化系统搭建和数据分析，帮助客户提升了30%的运营效率</p>
              <!-- <div class="case-studies-footer">
                <div class="case-studies-status">已完成</div>
                <div class="case-studies-date">2024年</div>
              </div> -->
            </div>
            <div class="case-studies-item">
              <img src="../assets/bg_gg.png" alt="电商平台建设" />
              <h3>电商平台建设</h3>
              <p>全栈式电商解决方案，实现了月销售额增长50%的显著成效</p>
              <!-- <div class="case-studies-footer">
                <div class="case-studies-status">已完成</div>
                <div class="case-studies-date">2024年</div>
              </div> -->
            </div>
            <div class="case-studies-item">
              <img src="../assets/bg_gs.png" alt="品牌广告策划" />
              <h3>品牌广告策划</h3>
              <p>创意广告策略实施，使品牌知名度提升了40%，市场反响热烈</p>
              <!-- <div class="case-studies-footer">
                <div class="case-studies-status">已完成</div>
                <div class="case-studies-date">2024年</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-partners">
      <img src="../assets/partners.png" alt="" />
    </div>
  </div>
</template>
<script>
import { getList } from "../utils/publish";
export default {
  name: "HomeView",
  data() {
    return {
      dataList: [],
      dataList2: [],
      dataList3: [],
      dataList4: [],
      options: [
        {
          label: "3万以下",
          value: "1",
        },
        {
          label: "3万-10万",
          value: "2",
        },
        {
          label: "10万-50万",
          value: "3",
        },
        {
          label: "50万以上",
          value: "4",
        },
      ],
    };
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    register() {
      this.$router.push("/register");
    },
    handleDetail(item) {
      this.$store.commit("SET_ACTIVE", -1);
      this.$router.push({ path: "/detail", query: { id: item.id } });
    },
    handleMore(path, index) {
      this.$store.commit("SET_ACTIVE", index);
      this.$router.push(path);
    },
  },
  activated() {
  },
};
</script>
<style scoped lang="less">
.normal() {
  display: flex;
  align-items: center;
}
.fontdemo(@size,@family,@weight,@color) {
  font-size: @size;
  font-family: @family;
  font-weight: @weight;
  color: @color;
}
.home {
  width: 100%;
  h2 {
    margin: 68px auto 44px;
    font-size: 47px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 77px;
  }
  &-top {
    .normal();
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    padding: 20px 37px 20px 100px;
    background: #ffffff;
    &-avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
    &-header {
      .normal();
      &-left {
        .normal();
        span {
          font-size: 18px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #242929;
          display: inline-block;
          margin-right: 37px;
          cursor: pointer;
        }
        :last-child {
          margin-right: 0;
        }
      }
      &-right {
        .normal();
        &-bottom {
          width: 120px;
          height: 52px;
          border-radius: 8px;
          .normal();
          justify-content: center;
          cursor: pointer;
        }
        .bottom1 {
          background: #f2f2f2;
          .fontdemo(18px, "PingFangSC,PingFang SC", 500, #000000);
          margin-right: 18px;
          margin-left: 102px;
        }
        .bottom2 {
          background: #4787f0;
          .fontdemo(18px, "PingFangSC,PingFang SC", 500, #FFFFFF);
        }
      }
    }
  }
  &-content {
    width: 100%;
    img {
      width: 100%;
      // height: 600px;
    }
  }
  .content{
    width: 100%;
    font-family: PingFangSC, PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif;
    margin-top: -10px;
    
    /* 核心业务模块 */
    .core-business{
      background: #232732;
      padding: 80px 20px;
      text-align: center;
      width: 100%;
      box-sizing: border-box;
      
      &-header{
        margin-bottom: 60px;
        h2{
          font-size: 28px;
          font-weight: 600;
          color: #ffffff;
          margin: 0 0 16px 0;
          line-height: 1.2;
        }
        p{
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.5;
        }
      }
      
      &-cards{
        display: flex;
        justify-content: center;
        gap: 24px;
        flex-wrap: wrap;
        max-width: 1200px;
        margin: 0 auto;
        flex-wrap: nowrap;
        
        .core-business-card{
          background: #121212;
          border-radius: 8px;
          padding: 32px 24px;
          width: 260px;
          text-align: left;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          height: 100%;
          
          &:hover{
            transform: translateY(-8px);
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4);
          }
          
          .core-business-icon{
            width: 56px;
            height: 56px;
            // border: 1px dashed #ffd700;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            flex-shrink: 0;
            
            img{
              width: 56px;
              height: 56px;
              /* 图标统一转为金色，匹配设计图 */
              filter: brightness(0) saturate(100%) invert(82%) sepia(76%) saturate(749%) hue-rotate(1deg) brightness(106%) contrast(102%);
            }
          }
          
          h3{
            font-size: 18px;
            font-weight: 600;
            color: #ffffff;
            margin: 0 0 12px 0;
            line-height: 1.3;
          }
          
          p{
            font-size: 13px;
            color: rgba(255, 255, 255, 0.6);
            line-height: 1.6;
            margin: 0 0 24px 0;
            flex-grow: 1;
          }
          
          .core-business-more{
            font-size: 13px;
            color: #ffd700;
            cursor: pointer;
            text-align: right;
            margin-top: auto;
            transition: opacity 0.2s ease;
            
            &:hover{
              opacity: 0.8;
              text-decoration: underline;
            }
          }
        }
      }
    }
    
    /* 数据统计模块 */
    .stats{
      background: #121212;
      padding: 60px 20px;
      display: flex;
      justify-content: center;
      gap: 220px;
      flex-wrap: wrap;
      width: 100%;
      box-sizing: border-box;
      
      .stats-item{
        text-align: center;
        
        .stats-number{
          font-size: 36px;
          font-weight: 700;
          color: #ffd700;
          margin-bottom: 8px;
          line-height: 1;
        }
        
        .stats-label{
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
          line-height: 1.2;
        }
      }
    }
    
    /* 成功案例模块 */
    .case-studies{
      background: #232732;
      padding: 80px 20px;
      width: 100%;
      box-sizing: border-box;
      
      &-header{
        text-align: center;
        margin-bottom: 60px;
        
        h2{
          font-size: 28px;
          font-weight: 600;
          color: #ffffff;
          margin: 0 0 16px 0;
          line-height: 1.2;
        }
        
        p{
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.5;
        }
      }
      
      &-grid{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 24px;
        max-width: 1200px;
        margin: 0 auto;
        
        .case-studies-item{
          background: #121212;
          border-radius: 8px;
          overflow: hidden;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          height: 100%;
          cursor: pointer;
          
          &:hover{
            transform: translateY(-8px);
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4);
          }
          
          img{
            width: 100%;
            height: 180px;
            object-fit: cover;
            display: block;
          }
          
          h3{
            font-size: 16px;
            font-weight: 600;
            color: #ffffff;
            margin: 20px 20px 10px 20px;
            line-height: 1.3;
          }
          
          p{
            font-size: 13px;
            color: rgba(255, 255, 255, 0.6);
            line-height: 1.6;
            margin: 0 20px 16px 20px;
            flex-grow: 1;
          }
          
          .case-studies-footer{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px 24px 20px;
            margin-top: auto;
            
            .case-studies-status{
              font-size: 12px;
              color: rgba(255, 255, 255, 0.7);
            }
            
            .case-studies-date{
              font-size: 12px;
              color: rgba(255, 255, 255, 0.4);
            }
          }
        }
      }
    }
  }
  &-partners {
    height: 451px;
    width: 100%;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>